var _circle, _rect, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPipedrive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 13.5,
    r: 11.5,
    fill: "#017737"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.1,
    y: 6.6,
    width: 3.1,
    height: 13.8,
    rx: 0.5,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.2,
    cy: 11.7,
    r: 5.1,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.2,
    cy: 11.7,
    r: 2.3,
    fill: "#017737"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPipedrive);
export default __webpack_public_path__ + "static/media/pipedrive.a66f43fb4c15cdd87622f1ecc9ad10e5.svg";
export { ForwardRef as ReactComponent };